/* eslint-disable no-param-reassign */
import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { API_CONFIG, API_LIST } from '../../Constants/ApiDefinations'
import { CreateUserRequestModal } from '../../Models'
import mainApiService from '../../Services'
import { setLoader } from './loader.slice'

interface UserDataModal {
  _id: string
  userName: string
  userEmail: string
  cyberarkId: string
  roleId: string
  status: string
  createdAt: string
  updatedAt: string
  comment?: string
}

interface UserState {
  user: string
  authConfig?: any
  userData?: UserDataModal | null
}

const initialState: UserState = {
  user: '',
  authConfig: null,
  userData: null,
}

const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<string>) => {
      state.user = action.payload
    },
    setAuthConfig: (state, action: PayloadAction<string>) => {
      state.authConfig = action.payload
    },
    setUserData: (state, action) => {
      state.userData = action.payload.data.records[0]
    },
  },
})

export const { setUser, setUserData, setAuthConfig } = userSlice.actions

export const createUserService = createAsyncThunk(
  'role/createUser',
  async (payload: CreateUserRequestModal, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData = API_CONFIG(API_LIST.USER.CREATE, payload)
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))

    return data
  },
)

export const updateUserService = createAsyncThunk(
  'role/updateUser',
  async (payload: CreateUserRequestModal, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData = API_CONFIG(
      API_LIST.USER.UPDATE,
      payload,
      { userId: payload.userId },
      null,
    )
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))

    return data
  },
)

export const changeUserStatus = createAsyncThunk(
  'role/changeStatus',
  async (payload: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData = API_CONFIG(
      API_LIST.USER.UPDATE,
      payload,
      { userId: payload.userId },
      null,
    )
    const result = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return result
  },
)

export const viewUserService = createAsyncThunk(
  'role/viewUser',
  async (id: string, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: any = API_CONFIG(API_LIST.USER.GET_DETAIL, null, { userId: id }, null)
    const data = await mainApiService(requestedData)
    dispatch(setUserData(data))
    dispatch(setLoader(false))

    return data
  },
)

export const getAssociatedUsers = createAsyncThunk(
  'role/getAssociatedUsers',
  async (paramsData: any, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData = API_CONFIG(API_LIST.USER.GET_LIST, null, null, paramsData)
    const data = await mainApiService(requestedData)
    dispatch(setLoader(false))
    return data
  },
)

const userSelector = (state: { user: UserState }) => state.user

export const selectAuthConfig = createSelector(userSelector, (state) => state.authConfig)
export const selectUser = createSelector(userSelector, (state) => state.user)
export const selectUserData = createSelector(userSelector, (state) => state.userData)

export default userSlice
